/** The server's own reason when it gives one, so a refusal reads as what the Facade said. */
export const errorMessage = (error: unknown, fallback: string): string => {
  const message = (error as { response?: { data?: { message?: unknown } } })?.response?.data?.message;
  if (typeof message === 'string' && message) {
    return message;
  }
  return error instanceof Error && error.message ? error.message : fallback;
};

export const formatWhen = (iso: string | null): string => (iso ? new Date(iso).toLocaleString() : 'never');
